import {setupStripeConnect} from './setupStripeConnect';

// This file simply sets up the Stripe Connect object on the window.
setupStripeConnect();
